import { createContext, useContext, useState, useEffect } from "react";
import { getCurrentUserClient, logoutClient } from "../services/auth";

const ClientAuthContext = createContext(undefined);

export function ClientAuthProvider({ children }) {
  const [currentClient, setCurrentClient] = useState(null);
  const [loading, setLoading] = useState(true);

  const handleClientLogin = async (clientData) => {
    setCurrentClient(clientData);
  };

  const handleClientLogout = async () => {
    try {
      const res = await logoutClient(currentClient?.userId);
      if (res) {
        setCurrentClient(null);
        localStorage.removeItem("clientLoginRequestID");
        localStorage.removeItem("clientToken");
      } else {
        console.error("error API logout");
      }
    } catch (error) {
      console.error("Logout error:", error);
      // Still clear the client state even if API call fails
      setCurrentClient(null);
      localStorage.removeItem("clientLoginRequestID");
      localStorage.removeItem("clientToken");
    }
  };

  const updateCurrentClient = async (clientInfo) => {
    const clientData = { ...currentClient, ...clientInfo };
    setCurrentClient(clientData);
  };

  useEffect(() => {
    const checkClientAuth = async () => {
      try {
        const clientId = localStorage.getItem("clientLoginRequestID");
        const token = localStorage.getItem("clientToken");
        
        if (clientId && token) {
          const client = await getCurrentUserClient();
          if (client) {
            setCurrentClient(client);
          } else {
            // If API call fails, clear the stored data
            localStorage.removeItem("clientLoginRequestID");
            localStorage.removeItem("clientToken");
          }
        }
      } catch (err) {
        console.error("Failed to check client auth:", err);
        localStorage.removeItem("clientLoginRequestID");
        localStorage.removeItem("clientToken");
        setCurrentClient(null);
      } finally {
        setLoading(false);
      }
    };

    checkClientAuth();
  }, []);

  return (
    <ClientAuthContext.Provider
      value={{ 
        currentClient, 
        handleClientLogin, 
        handleClientLogout, 
        updateCurrentClient,
        loading 
      }}
    >
      {children}
    </ClientAuthContext.Provider>
  );
}

export function useClientAuth() {
  const context = useContext(ClientAuthContext);

  if (context === undefined) {
    throw new Error("useClientAuth must be used inside of a ClientAuthProvider");
  }

  return context;
}
